import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AuthHttpService {
  constructor(private http: HttpClient) {}

  getUserByToken() {
    console.log("run get UserByToken");

    return this.http.get<any>("users/getUserToken");
  }
}
